/**
 * The price to use for a basket item's totals: the server-validated
 * `currentPrice` (written by the pre-checkout validate when it differs from
 * the stamped figure) when present, otherwise the `price` stamped when the
 * item was added to the basket.
 *
 * Shared by the widget and webcomponents basket stores so their displayed
 * grand totals match the amount `CreateBasketCheckoutSession` actually charges.
 *
 * `??` not `||`: a legitimately-£0 `currentPrice` (free ticket,
 * membership-covered, 100%-off rule) must win over the stamped price.
 */
export function effectiveItemPrice(item: {
  price: number;
  currentPrice?: number | null;
}): number {
  return item.currentPrice ?? item.price;
}
